"use strict";require("react");var r=require("react/jsx-runtime");exports.default=()=>r.jsx(r.Fragment,{children:"Abrir Modal de Contato Seguro"});